import React, { useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, Send } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription:', email);
    setEmail('');
  };
  return <footer className="bg-white pt-20 border-t border-neutral-100" data-id="element-89">
      <div className="container mx-auto px-4" data-id="element-90">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16" data-id="element-91">
          {/* Brand Column */}
          <div className="lg:col-span-4" data-id="element-92">
            <Link to="/" className="inline-block mb-6" data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/q5Ztjxw6wMTJUKnKcgWE7C/SFRR_logo.png" alt="SFRR Foundation Logo" className="h-16 w-auto" loading="lazy" width="200" height="64" data-id="element-94" />
            </Link>
            <p className="text-neutral-600 mb-6 leading-relaxed" data-id="element-95">
              A non-profit, non-political organization committed to improving
              lives and strengthening communities across Nigeria through
              sustainable development and humanitarian service.
            </p>
            <p className="text-sm text-neutral-500 mb-6" data-id="element-96">
              RC 157857 • Touching Lives. Building Futures.
            </p>
            <div className="flex gap-4" data-id="element-97">
              {[{
              Icon: Facebook,
              href: 'https://facebook.com/sfrrfoundation',
              label: 'Facebook'
            }, {
              Icon: Twitter,
              href: 'https://twitter.com/sfrrfoundation',
              label: 'Twitter'
            }, {
              Icon: Instagram,
              href: 'https://instagram.com/sfrrfoundation',
              label: 'Instagram'
            }, {
              Icon: Linkedin,
              href: 'https://linkedin.com/company/sfrrfoundation',
              label: 'LinkedIn'
            }].map(({
              Icon,
              href,
              label
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-charcoal hover:bg-primary hover:text-white transition-all duration-300 hover:scale-110" aria-label={label} data-id="element-98">
                  <Icon size={18} data-id="element-99" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2" data-id="element-100">
            <h4 className="font-bold text-lg mb-6 text-charcoal" data-id="element-101">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-102">
              {[{
              name: 'About Us',
              path: '/about'
            }, {
              name: 'Our Programs',
              path: '/programs'
            }, {
              name: 'Impact',
              path: '/impact'
            }, {
              name: 'Stories',
              path: '/stories'
            }, {
              name: 'Structure',
              path: '/structure'
            }, {
              name: 'Get Involved',
              path: '/get-involved'
            }].map(item => <li key={item.path} data-id="element-103">
                  <Link to={item.path} className="text-neutral-600 hover:text-primary transition-colors hover:translate-x-1 inline-block" data-id="element-104">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-3" data-id="element-105">
            <h4 className="font-bold text-lg mb-6 text-charcoal" data-id="element-106">Contact Us</h4>
            <ul className="space-y-4" data-id="element-107">
              <li data-id="element-108">
                <p className="text-sm font-semibold text-charcoal mb-2" data-id="element-109">
                  Head Office
                </p>
                <div className="flex items-start gap-3 text-neutral-600" data-id="element-110">
                  <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" data-id="element-111" />
                  <span data-id="element-112">
                    Suite 48A, Shakir Plaza
                    <br data-id="element-113" />
                    Behind Assembly of God Church
                    <br data-id="element-114" />
                    Garki, Abuja. Nigeria
                  </span>
                </div>
              </li>
              <li data-id="element-115">
                <p className="text-sm font-semibold text-charcoal mb-2" data-id="element-116">
                  Branch Office
                </p>
                <div className="flex items-start gap-3 text-neutral-600" data-id="element-117">
                  <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" data-id="element-118" />
                  <span data-id="element-119">
                    Obayemi Mall
                    <br data-id="element-120" />
                    22A, Similoluwa Hospital Road
                    <br data-id="element-121" />
                    Ado-Ekiti, Ekiti State. Nigeria
                  </span>
                </div>
              </li>
              <li className="flex items-center gap-3 text-neutral-600" data-id="element-122">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" data-id="element-123" />
                <a href="tel:+2348033304041" className="hover:text-primary transition-colors" data-id="element-124">
                  +234 803 330 4041
                </a>
              </li>
              <li className="flex items-center gap-3 text-neutral-600" data-id="element-125">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" data-id="element-126" />
                <a href="mailto:fatimarasakifoundation@gmail.com" className="hover:text-primary transition-colors break-all" data-id="element-127">
                  fatimarasakifoundation@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-3" data-id="element-128">
            <h4 className="font-bold text-lg mb-6 text-charcoal" data-id="element-129">
              Stay Updated
            </h4>
            <p className="text-neutral-600 mb-4 text-sm" data-id="element-130">
              Subscribe to our newsletter for the latest updates and impact
              stories.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-3" data-id="element-131">
              <div className="relative" data-id="element-132">
                <input type="email" placeholder="Your email address" value={email} onChange={e => setEmail(e.target.value)} required className="w-full px-4 py-3 pr-12 rounded-lg border-2 border-neutral-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" aria-label="Email address for newsletter" data-id="element-133" />
                <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-primary text-white rounded-md flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Subscribe to newsletter" data-id="element-134">
                  <Send size={16} data-id="element-135" />
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="border-t border-neutral-100 py-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-136">
          <p className="text-neutral-500 text-sm" data-id="element-137">
            &copy; {currentYear} Senator Fatimat Raji Rasaki Foundation. All
            rights reserved. RC 157857
          </p>
          <div className="flex gap-6 text-sm text-neutral-500" data-id="element-138">
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-139">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-140">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}